import { Fragment, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { sortBy } from 'underscore';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { LanguageIcon } from 'foundations-assets';
import { Select } from 'foundations-components/transitional/components/Select';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { selectArticleLanguageOptions, selectArticleId } from '../../settings/selectors/articleInstanceSelectors';
import { selectKnowledgeBaseHasLoaded, selectPrimaryKnowledgeBase } from '../../settings/selectors/knowledgeBaseSelectors';
import { getEditorUrl } from '../../utils/urls';
import { getTranslatedLanguageName } from '../../utils/lang';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TranslationSelectorContainer = () => {
  const articleId = useSelector(selectArticleId);
  const translations = useSelector(selectArticleLanguageOptions);
  const kbHasLoaded = useSelector(selectKnowledgeBaseHasLoaded);
  const primaryKnowledgeBase = useSelector(selectPrimaryKnowledgeBase);
  const onChangeTranslation = evt => {
    if (articleId.toString() !== evt.target.value) {
      window.location.href = getEditorUrl(evt.target.value);
    }
  };
  const getTranslationOptions = useCallback(() => {
    if (primaryKnowledgeBase) {
      return sortBy(translations, 'text').map(option => {
        const isMasterLang = primaryKnowledgeBase.values.hs_language === option.language;
        if (isMasterLang) {
          option.text = I18n.text('translationSelector.masterLanguage', {
            language: getTranslatedLanguageName(option.language)
          });
        }
        return option;
      });
    }
    return [];
  }, [translations, primaryKnowledgeBase]);
  function makeButtonTextRenderer() {
    const translation = translations.find(({
      value
    }) => value === articleId);
    return () => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineEnd: "100",
        children: /*#__PURE__*/_jsx(LanguageIcon, {})
      }), translation && translation.text]
    });
  }
  if (!kbHasLoaded || translations.length < 2) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "translationSelector.tooltip"
      }),
      placement: "right",
      marginInlineEnd: "300",
      children: /*#__PURE__*/_jsx(Select, {
        "data-test-id": "translation-select",
        marginInlineStart: "100",
        defaultValue: articleId,
        menuWidth: 300,
        onChange: onChangeTranslation,
        options: getTranslationOptions(),
        ButtonContent: makeButtonTextRenderer()
      })
    })
  });
};
export default TranslationSelectorContainer;